import React from 'react'
import { templateImgStyle } from './styles'
import { zoomImage } from '../../../../actions/static'
import CenteredLoader from '../../../view/CenteredLoader'

export const Image = props => {
  const { classes } = props

  return (
    <div
      className={classes.templateImg}
      style={templateImgStyle(props.device, props.url, props.received)}
      onClick={zoomImage.bind(
        null,
        props.url,
        props.isFullScreenWidget,
        props.parentURL,
      )}>
      <div className={classes.templateImgSpinnerContainer}>
        <CenteredLoader size={24} color={props.color} />
      </div>
    </div>
  )
}
